/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { get } from '../../../services/GenesisApi';
import {
  GET_PRODUCERS,
  PRODUCER_ACTUAL_DELIVERIES,
} from '../../../constants/Cva';
import {
  IProducers,
  IProducerDeliveries,
} from '../../../types/ProducerDeliveries.type';

export interface IProducerDeliveriesState {
  loadingProducers: boolean;
  producers: IProducers[];
  loadingProducerDeliveries: boolean;
  producerDeliveries: IProducerDeliveries[];
}

export const initialState: IProducerDeliveriesState = {
  loadingProducers: false,
  producers: [],
  loadingProducerDeliveries: true,
  producerDeliveries: [],
};

export const getAllProducers = createAsyncThunk(
  'producerDeliveries/getAllProducers',
  async () => {
    return get(GET_PRODUCERS, {})
      .then((response) => {
        const data = response.data || [];
        return data.sort((a, b) => a.name.localeCompare(b.name));
      })
      .catch((error) => {
        throw error;
      });
  }
);

export const getAllProducerDeliveries = createAsyncThunk(
  'producerDeliveries/getAllProducerDeliveries',
  async (payload: { gasDay: string; producerId: number | null }) => {
    const { gasDay, producerId } = payload;

    return get(
      producerId
        ? `${PRODUCER_ACTUAL_DELIVERIES}?gasDay=${gasDay}&producerId=${producerId}`
        : `${PRODUCER_ACTUAL_DELIVERIES}?gasDay=${gasDay}`,
      {}
    )
      .then((response) => {
        return response.data ?? [];
      })
      .catch((error) => {
        throw error;
      });
  }
);

const producerDeliveries = createSlice({
  name: 'producerDeliveries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducers.pending, (state: IProducerDeliveriesState) => {
        state.loadingProducers = true;
        state.producers = [];
      })
      .addCase(
        getAllProducers.fulfilled,
        (
          state: IProducerDeliveriesState,
          { payload }: PayloadAction<IProducers[]>
        ) => {
          state.loadingProducers = false;
          state.producers = payload;
        }
      )
      .addCase(getAllProducers.rejected, (state: IProducerDeliveriesState) => {
        state.loadingProducers = false;
      })

      .addCase(
        getAllProducerDeliveries.pending,
        (state: IProducerDeliveriesState) => {
          state.loadingProducerDeliveries = true;
          state.producerDeliveries = [];
        }
      )
      .addCase(
        getAllProducerDeliveries.fulfilled,
        (
          state: IProducerDeliveriesState,
          { payload }: PayloadAction<IProducerDeliveries[]>
        ) => {
          state.loadingProducerDeliveries = false;
          state.producerDeliveries = payload;
        }
      )
      .addCase(
        getAllProducerDeliveries.rejected,
        (state: IProducerDeliveriesState) => {
          state.loadingProducerDeliveries = false;
        }
      );
  },
});

export const producerDeliveriesActions = producerDeliveries.actions;
export default producerDeliveries.reducer;
